// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vue from 'vue'
import App from './App'
import router from '@/router'
import BootstrapVue from 'bootstrap-vue'
// https://bootstrap-vue.org/docs/components/modal
import YmapPlugin from 'vue-yandex-maps'
// https://vue-yandex-maps.github.io/guide/#%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D0%B0
// https://vue-yandex-maps.github.io/examples/#%D0%BF%D0%B5%D1%80%D0%B5%D0%BC%D0%B5%D1%89%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BC%D0%B0%D1%80%D0%BA%D0%B5%D1%80%D0%B0-%D0%BF%D0%BE-%D0%BAn%D0%B8%D0%BA%D1%83
import { store } from './store/store'
// vuelidate https://vuelidate.js.org/#sub-builtin-validators
import InputMask from 'vue-input-mask'
// https://www.npmjs.com/package/vue-input-mask
import vueDebounce from 'vue-debounce'
// https://www.npmjs.com/package/vue-debounce
import Meta from 'vue-meta'
// https://www.npmjs.com/package/vue-meta
const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)
// https://www.npmjs.com/package/vue-inputmask

Vue.config.productionTip = false

const settings = {
  apiKey: 'f1a40403-b6e4-488e-a5ea-a196834982c6',
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1'
}
Vue.use(YmapPlugin, settings)
Vue.use(BootstrapVue)
Vue.use(vueDebounce)
Vue.component('input-mask', InputMask)
Vue.use(Meta)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: {
    show: false
  }
})



// WEBPACK FOOTER //
// ./src/main.js